
import { CERTIFICATE_PROVIDERS } from "~/config/_constants";

export default {
  name: "ProductCertificateLogos",
  props: {
    provider: {
      type: String,
      default: "",
    },
  },
  computed: {
    normalizedProvider() {
      return (this.provider || "").toUpperCase();
    },
    isIgi() {
      return this.normalizedProvider === CERTIFICATE_PROVIDERS.IGI;
    },
    isGia() {
      return this.normalizedProvider === CERTIFICATE_PROVIDERS.GIA;
    },
  },
};
